<script lang="ts">
    import { reviewsApplicationLoggerToken } from "@apps/reviews/tokens";
    import ReviewsListWidget from "@apps/reviews/widgets/reviews_list_widget/ReviewsListWidget";
    import { ProductIdFromStaticProvider } from "@lib/ProductIdManager/ProductIdFromStaticProvider";
    import { ProductIdManager } from "@lib/ProductIdManager/ProductIdManager";
    import { container } from "tsyringe";

    import Widget from "@components/Widget.svelte";

    export let productId: number;

    const productIdManager = new ProductIdManager();
    let productIdFromStaticProvider: ProductIdFromStaticProvider;

    const updateProductId = (productId: number) => {
        if (productIdFromStaticProvider) {
            productIdManager.unregisterProvider(productIdFromStaticProvider);
        }
        productIdFromStaticProvider = new ProductIdFromStaticProvider(
            productId
        );
        productIdManager.registerProvider(productIdFromStaticProvider);
    };
    $: {
        updateProductId(productId);
    }
</script>

<Widget
    widget={ReviewsListWidget}
    params={[
        {
            reviewsPerPage: 2,
            isWidgetShadowRootEnabled: false,
            productIdManager,
            showAddReviewButton: false,
            showAddReviewButtonInEmptyList: false,
        },
        container.resolve(reviewsApplicationLoggerToken),
    ]}
/>
